import { Container, Row, Col, Button } from "react-bootstrap";
import AllDomainValue from '../../utils/mescs.json';
import Keywords from '../../utils/keywords.json';
import Banks from '../../utils/banks.json';
import Province from '../../utils/province.json';
import City from '../../utils/city.json';
import axios from 'axios';
import { useContext, useEffect, useState } from "react";
import { MyContext } from "../helper/MyContext";
const FormData = require('form-data');

export default function StepFour(props) {
    const url = 'https://khpc.ir/sup-upload/';
    const [loading, setLoading] = useState(false);
    const [submit, setSubmit] = useState(false);
    const { user } = useContext(MyContext);

    useEffect(() => {
        setSubmit(false)
    }, [props.step])

    const sendRequest = () => {
        if (!submit) {

            setLoading(true);

            var json = {
                stepOne: props.dataStepOne,
                stepTwo: props.dataStepTwo,
                stepThree: props.dataStepThree,
                stepFour: props.dataStepFour
            }

            let data = new FormData();

            data.append('type', props.type);
            data.append('nationalCode', props.nationalCode);
            data.append('idInternationalCode', props.idInternationalCode);
            data.append('economicCodeCompany', props.economicCodeCompany);
            data.append('userId', user);
            data.append('requestId', props.requestId);
            data.append('json', JSON.stringify(json));

            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: 'https://khpc.ir/api-supplier/api/sendrequest',
                data: data
            };

            axios.request(config)
                .then((response) => {
                    if (response.data.error) {
                        alert(response.data.message);
                    } else {
                        setSubmit(true);
                        alert('تامین کننده گرامی، درخواست شما با موفقیت ثبت شد');
                    }

                    setLoading(false);
                })
                .catch((error) => {
                    alert('تامین کننده گرامی، درخواست شما با خطا مواجه شد لطفا با پشتیبانی تماس بگیرید');
                    setLoading(false);
                });
        } else {
            alert('تامین کننده گرامی، درخواست شما با موفقیت ثبت شده است');
        }
    }

    const typeCompany = (id) => {
        switch (id) {
            case '1':
                return "سهامی خاص";
            case '2':
                return "سهامی عام";
            case '3':
                return "مسئولیت محدود";
            case '4':
                return "تعاونی";
            case '5':
                return props.dataStepOne?.otherTypeCompany;
            default:
                return '';
                break;
        }
    }

    return (
        <Container>
            <Row>
                <Col xs={12}>
                    <p>اطلاعات زیر را بررسی کرده و در صورت تایید، ثبت نهایی را بزنید</p>
                </Col>
                <Col xs={12} className="mt-4 py-2" style={{ backgroundColor: '#1f3870', color: 'white' }}>
                    <label className="text-g fw-bold">مشخصات</label>
                </Col>
                <Col xs={12} md={4} className="py-2">
                    <div className="d-flex">
                        <div className="fw-bold">شخصیت</div>
                        <div className="mx-2">{props.dataStepOne?.type == 1 ? 'حقیقی' : 'حقوقی'}</div>
                    </div>
                </Col>
                <Col xs={12} md={4} className="py-2">
                    <div className="d-flex">
                        <div className="fw-bold">شخصیت</div>
                        <div className="mx-2">{props.dataStepOne?.builder && 'سازنده- '} {props.dataStepOne?.commerce && 'بازرگانی- '} {props.dataStepOne?.service && 'خدماتی- '} {props.dataStepOne?.contractor && 'پیمانکار'}</div>
                    </div>
                </Col>

                {
                    props.dataStepOne?.type == 1
                        ?
                        <>
                            <Col xs={12} md={4} className="py-2">
                                <div className="d-flex">
                                    <div className="fw-bold">نام فروشگاه</div>
                                    <div className="mx-2">{props.dataStepOne?.store}</div>
                                </div>
                            </Col>
                            <Col xs={12} md={4} className="py-2">
                                <div className="d-flex">
                                    <div className="fw-bold">نام قدیم فروشگاه</div>
                                    <div className="mx-2">{props.dataStepOne?.oldStore}</div>
                                </div>
                            </Col>
                            <Col xs={12} md={4} className="py-2">
                                <div className="d-flex">
                                    <div className="fw-bold">تاریخ تاسیس فروشگاه</div>
                                    <div className="mx-2">{props.dataStepOne?.establishmentStore}</div>
                                </div>
                            </Col>
                            <Col xs={12} md={4} className="py-2">
                                <div className="d-flex">
                                    <div className="fw-bold">شماره پروانه کسب</div>
                                    <div className="mx-2">{props.dataStepOne?.businessLicense}</div>
                                </div>
                            </Col>
                            <Col xs={12} md={4} className="py-2">
                                <div className="d-flex">
                                    <div className="fw-bold">کد اقتصادی</div>
                                    <div className="mx-2">{props.dataStepOne?.economicCode}</div>
                                </div>
                            </Col>
                            <Col xs={12} md={4} className="py-2">
                                <div className="d-flex">
                                    <div className="fw-bold">کد ملی</div>
                                    <div className="mx-2">{props.dataStepOne?.nationalCode}</div>
                                </div>
                            </Col>
                        </>
                        :
                        <>
                            <Col xs={12} md={4} className="py-2">
                                <div className="d-flex">
                                    <div className="fw-bold">نوع شرکت</div>
                                    <div className="mx-2">{typeCompany(props.dataStepOne?.typeCompany)}</div>
                                </div>
                            </Col>
                            <Col xs={12} md={4} className="py-2">
                                <div className="d-flex">
                                    <div className="fw-bold">نام شرکت</div>
                                    <div className="mx-2">{props.dataStepOne?.companyName}</div>
                                </div>
                            </Col>
                            <Col xs={12} md={4} className="py-2">
                                <div className="d-flex">
                                    <div className="fw-bold">نام قدیم شرکت</div>
                                    <div className="mx-2">{props.dataStepOne?.oldCompanyName}</div>
                                </div>
                            </Col>
                            <Col xs={12} md={4} className="py-2">
                                <div className="d-flex">
                                    <div className="fw-bold">شماره ثبت شرکت</div>
                                    <div className="mx-2">{props.dataStepOne?.registerCodeCompany}</div>
                                </div>
                            </Col>
                            <Col xs={12} md={4} className="py-2">
                                <div className="d-flex">
                                    <div className="fw-bold">تاریخ ثبت شرکت</div>
                                    <div className="mx-2">{props.dataStepOne?.registerDateCompany}</div>
                                </div>
                            </Col>
                            <Col xs={12} md={4} className="py-2">
                                <div className="d-flex">
                                    <div className="fw-bold">کد شناسه ملی</div>
                                    <div className="mx-2">{props.dataStepOne?.idInternationalCode}</div>
                                </div>
                            </Col>
                            <Col xs={12} md={4} className="py-2">
                                <div className="d-flex">
                                    <div className="fw-bold">کد اقتصادی</div>
                                    <div className="mx-2">{props.dataStepOne?.economicCodeCompany}</div>
                                </div>
                            </Col>
                            <Col xs={12} md={4} className="py-2">
                                <div className="d-flex">
                                    <div className="fw-bold">سرمایه شرکت</div>
                                    <div className="mx-2">{props.dataStepOne?.companyCapital}</div>
                                </div>
                            </Col>
                            <Col xs={12} md={4} className="py-2">
                                <div className="d-flex">
                                    <div className="fw-bold">نام مدیر عامل</div>
                                    <div className="mx-2">{props.dataStepOne?.managerName}</div>
                                </div>
                            </Col>

                        </>



                }

                <Col xs={12} className="mt-4 py-2" style={{ backgroundColor: '#1f3870', color: 'white' }}>
                    <label className="text-g fw-bold">آدرس</label>
                </Col>
                <Col xs={12} md={4} className="py-2">
                    <div className="d-flex">
                        <div className="fw-bold">استان</div>
                        <div className="mx-2">{props.dataStepOne?.province && Province.find(item => item.province_id == props.dataStepOne?.province).province_name}</div>
                    </div>
                </Col>
                <Col xs={12} md={4} className="py-2">
                    <div className="d-flex">
                        <div className="fw-bold">شهر</div>
                        <div className="mx-2">{props.dataStepOne?.city && City.find(item => item.city_id == props.dataStepOne?.city).city_name}</div>
                    </div>
                </Col>
                <Col xs={12} md={4} className="py-2">
                    <div className="d-flex">
                        <div className="fw-bold">کد پستی</div>
                        <div className="mx-2">{props.dataStepOne?.postalcode}</div>
                    </div>
                </Col>
                <Col xs={12} md={4} className="py-2">
                    <div className="d-flex">
                        <div className="fw-bold">صندوق پستی</div>
                        <div className="mx-2">{props.dataStepOne?.postBox}</div>
                    </div>
                </Col>
                <Col xs={12} className="py-2">
                    <div className="d-flex">
                        <div className="fw-bold">آدرس</div>
                        <div className="mx-2">{props.dataStepOne?.address}</div>
                    </div>
                </Col>
                <Col xs={12} md={4} className="py-2">
                    <div className="d-flex">
                        <div className="fw-bold">تلفن</div>
                        <div className="mx-2">{props.dataStepOne?.cityCode}-{props.dataStepOne?.phone}</div>
                    </div>
                </Col>
                <Col xs={12} md={4} className="py-2">
                    <div className="d-flex">
                        <div className="fw-bold">تلفن</div>
                        <div className="mx-2">{props.dataStepOne?.cityCode}-{props.dataStepOne?.phoneTwo}</div>
                    </div>
                </Col>
                <Col xs={12} md={4} className="py-2">
                    <div className="d-flex">
                        <div className="fw-bold">تلفن</div>
                        <div className="mx-2">{props.dataStepOne?.cityCode}-{props.dataStepOne?.phoneThree}</div>
                    </div>
                </Col>
                <Col xs={12} md={4} className="py-2">
                    <div className="d-flex">
                        <div className="fw-bold">نمابر</div>
                        <div className="mx-2">{props.dataStepOne?.fax}</div>
                    </div>
                </Col>
                <Col xs={12} md={4} className="py-2">
                    <div className="d-flex">
                        <div className="fw-bold">پست الکترونیکی</div>
                        <div className="mx-2">{props.dataStepOne?.email}</div>
                    </div>
                </Col>

                <Col xs={12} md={4}>
                    <div className="d-flex">
                        <div className="fw-bold">آدرس وبسایت</div>
                        <div className="mx-2">{props.dataStepOne?.website}</div>
                    </div>
                </Col>
                <Col xs={12} className="mt-4 py-2" style={{ backgroundColor: '#1f3870', color: 'white' }}>
                    <label className="text-g fw-bold">بانک</label>
                </Col>
                <Col xs={12} md={4} className="py-2">
                    <div className="d-flex">
                        <div className="fw-bold">بانك</div>
                        <div className="mx-2">{props.dataStepOne?.bank && Banks.find(item => item.id == props.dataStepOne?.bank).name}</div>
                    </div>
                </Col>
                <Col xs={12} md={4} className="py-2">
                    <div className="d-flex">
                        <div className="fw-bold">شعبه</div>
                        <div className="mx-2">{props.dataStepOne?.branch}</div>
                    </div>
                </Col>
                <Col xs={12} md={4} className="py-2">
                    <div className="d-flex">
                        <div className="fw-bold">شبا</div>
                        <div className="mx-2">{props.dataStepOne?.shaba}</div>
                    </div>
                </Col>
                <Col xs={12} md={4} className="py-2">
                    <div className="d-flex">
                        <div className="fw-bold">شماره حساب</div>
                        <div className="mx-2">{props.dataStepOne?.accountNumber}</div>
                    </div>
                </Col>
                <Col xs={12} md={4} className="py-2">
                    <div className="d-flex">
                        <div className="fw-bold">بنام</div>
                        <div className="mx-2">{props.dataStepOne?.ownerName}</div>
                    </div>
                </Col>
                <Col xs={12} className="mt-4 py-2" style={{ backgroundColor: '#1f3870', color: 'white' }}>
                    <label className="text-g fw-bold">بانک دوم</label>
                </Col>
                <Col xs={12} md={4} className="py-2">
                    <div className="d-flex">
                        <div className="fw-bold">بانك</div>
                        <div className="mx-2">{props.dataStepOne?.bankTwo && Banks.find(item => item.id == props.dataStepOne?.bankTwo).name}</div>
                    </div>
                </Col>
                <Col xs={12} md={4} className="py-2">
                    <div className="d-flex">
                        <div className="fw-bold">شعبه</div>
                        <div className="mx-2">{props.dataStepOne?.branchTwo}</div>
                    </div>
                </Col>
                <Col xs={12} md={4} className="py-2">
                    <div className="d-flex">
                        <div className="fw-bold">شبا</div>
                        <div className="mx-2">{props.dataStepOne?.shabaTwo}</div>
                    </div>
                </Col>
                <Col xs={12} md={4} className="py-2">
                    <div className="d-flex">
                        <div className="fw-bold">شماره حساب</div>
                        <div className="mx-2">{props.dataStepOne?.accountNumberTwo}</div>
                    </div>
                </Col>
                <Col xs={12} md={4} className="py-2">
                    <div className="d-flex">
                        <div className="fw-bold">بنام</div>
                        <div className="mx-2">{props.dataStepOne?.ownerNameTwo}</div>
                    </div>
                </Col>


                <Col xs={12} className="mt-4 py-2" style={{ backgroundColor: '#1f3870', color: 'white' }}>
                    <label className="text-g fw-bold">اسناد و مدارک</label>
                </Col>

                {
                    props.dataStepOne?.type == '2' ?
                        (
                            <>
                                <Col xs={12} md={4} className="py-2">
                                    <div className="d-flex">
                                        <div className="fw-bold">اساسنامه شرکت</div>
                                        <div className="mx-2">
                                            {
                                                props.dataStepTwo?.statute &&
                                                <a target="_blank" className="mb-2" href={url + props.dataStepTwo?.statute} download>نمایش فایل</a>
                                            }
                                        </div>
                                    </div>
                                </Col>
                                <Col xs={12} md={4} className="py-2">
                                    <div className="d-flex">
                                        <div className="fw-bold">آگهی تاسیس</div>
                                        <div className="mx-2">
                                            {
                                                props.dataStepTwo?.founded &&
                                                <a target="_blank" className="mb-2" href={url + props.dataStepTwo?.founded} download>نمایش فایل</a>
                                            }
                                        </div>
                                    </div>
                                </Col>
                                <Col xs={12} md={4} className="py-2">
                                    <div className="d-flex">
                                        <div className="fw-bold">گواهی کداقتصادی</div>
                                        <div className="mx-2">
                                            {
                                                props.dataStepTwo?.economicCodeCertificate &&
                                                <a target="_blank" className="mb-2" href={url + props.dataStepTwo?.economicCodeCertificate} download>نمایش فایل</a>
                                            }
                                        </div>
                                    </div>
                                </Col>
                                <Col xs={12} md={4} className="py-2">
                                    <div className="d-flex">
                                        <div className="fw-bold">گواهی شناسه ملی </div>
                                        <div className="mx-2">
                                            {
                                                props.dataStepTwo?.nationalIDCertificate &&
                                                <a target="_blank" className="mb-2" href={url + props.dataStepTwo?.nationalIDCertificate} download>نمایش فایل</a>
                                            }
                                        </div>
                                    </div>
                                </Col>
                                <Col xs={12} md={4} className="py-2">
                                    <div className="d-flex">
                                        <div className="fw-bold">گواهی ارزش افزوده</div>
                                        <div className="mx-2">
                                            {
                                                props.dataStepTwo?.certificateOfAddedValue &&
                                                <a target="_blank" className="mb-2" href={url + props.dataStepTwo?.certificateOfAddedValue} download>نمایش فایل</a>
                                            }
                                        </div>
                                    </div>
                                </Col>
                                <Col xs={12} md={4} className="py-2">
                                    <div className="d-flex">
                                        <div className="fw-bold">آگهی تغییرات</div>
                                        <div className="mx-2">
                                            {
                                                props.dataStepTwo?.certificateOfChange &&
                                                <a target="_blank" className="mb-2" href={url + props.dataStepTwo?.certificateOfChange} download>نمایش فایل</a>
                                            }
                                        </div>
                                    </div>
                                </Col>


                            </>
                        )
                        :
                        (
                            <>
                                <Col xs={12} md={4} className="py-2">
                                    <div className="d-flex">
                                        <div className="fw-bold">بروشور و مدارک فنی</div>
                                        <div className="mx-2">
                                            {
                                                props.dataStepTwo?.catalogs &&
                                                <a target="_blank" className="mb-2" href={url + props.dataStepTwo?.catalogs} download>نمایش فایل</a>
                                            }
                                        </div>
                                    </div>
                                </Col>
                                <Col xs={12} md={4} className="py-2">
                                    <div className="d-flex">
                                        <div className="fw-bold">کارت ملی</div>
                                        <div className="mx-2">
                                            {
                                                props.dataStepTwo?.nationalCard &&
                                                <a target="_blank" className="mb-2" href={url + props.dataStepTwo?.nationalCard} download>نمایش فایل</a>
                                            }
                                        </div>
                                    </div>
                                </Col>
                                <Col xs={12} md={4} className="py-2">
                                    <div className="d-flex">
                                        <div className="fw-bold">جواز کسب</div>
                                        <div className="mx-2">
                                            {
                                                props.dataStepTwo?.license &&
                                                <a target="_blank" className="mb-2" href={url + props.dataStepTwo?.license} download>نمایش فایل</a>
                                            }
                                        </div>
                                    </div>
                                </Col>
                            </>
                        )
                }

                <Col xs={12} className="mt-4 py-2" style={{ backgroundColor: '#1f3870', color: 'white' }}>
                    <label className="text-g fw-bold">نوع فعالیت</label>
                </Col>
                <Col xs={12} className="py-2">
                    <div className="d-flex">
                        <div className="fw-bold">دامنه فعالیت</div>
                        <div className="mx-2">
                            {
                                props.dataStepThree?.scopeActivity.map((item, index) => {
                                    return <span key={index}> {AllDomainValue.find(ite => ite.id == item)?.PersianTitle} {props.dataStepThree?.scopeActivity.length - 1 !== index && '،'}</span>
                                })
                            }
                        </div>
                    </div>
                </Col>
                <Col xs={12} className="py-2">
                    <div className="d-flex">
                        <div className="fw-bold">نوع فعالیت</div>
                        <div className="mx-2">
                            {
                                props.dataStepThree?.activity.map((item, index) => {
                                    if (item.checked) {
                                        return <span key={index}>{item.label}</span>
                                    } else {
                                        return '';
                                    }
                                })
                            }
                        </div>
                    </div>
                </Col>

                <Col xs={12} className="py-2">
                    <div className="d-flex">
                        <div className="fw-bold">توضیحات</div>
                        <div className="mx-2">{props.dataStepThree?.descriptionActivity}</div>
                    </div>
                </Col>

                <Col xs={12} className="mt-4 text-center">
                    <div className="d-grid gap-2">
                        <Button disabled={loading} variant="success" onClick={(e) => sendRequest()}>
                            {
                                loading ?
                                    'در حال ثبت'
                                    :
                                    'ثبت نهایی'
                            }
                        </Button>
                        <Button variant="muted" className="mt-2" onClick={() => props.backStep()}>
                            مرحله قبل
                        </Button>
                    </div>
                </Col>

            </Row>
        </Container>
    )
}













